import { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import ProtectedRoute from "../router/ProtectedRoute";
import ScrollToTop from "../Component/ScrollToTop";
import PrivacyPolicy from "../features/Policy/PrivacyPolicy";
import AboutUs from "../features/Pages/about/AboutUS";
import LoyaltyTerms from "../features/Policy/LoyaltyTerms";
import ChangePassword from "../features/Auth/pages/ChangePassword";
import WOW from "wowjs";
import Homepage from "../features/Home/pages/Homepage";
import BottomPanel from "../Component/footer/BottomPanel";
import Footer from "../Component/footer/Footer";
import MobileVersionGrid from "../features/Product/component/Mobileview/MobileVirsionGrid";
import Wishlist from "../features/Pages/wishlist/Wishlist";
import Navigationbar from "../Component/header/Navigationbar";
import Notfound from "../Component/error/Notfound";
import AuthLoginPage from "../features/Auth/pages/AuthLoginPage";
import CustomerPage from "../features/Account/pages/customers/CustomerPage";
import MyOrders from "../features/Account/pages/orders/MyOrder";
import HoldOrder from "../features/Account/pages/orders/HoldOrder";
import OrderDetails from "../features/Account/pages/orders/OrderDetails";
import Dashboard from "../features/Account/pages/dashboard/Dashboard";
import MyProfile from "../features/Account/pages/profile/MyProfile";
import Mycollection from "../features/Account/pages/collections/Mycollection";
import CustomerOrder from "../features/Account/pages/orders/CustomerOrder";
import CartPage from "../features/Checkout/pages/CartPage";
import CheckoutSummary from "../features/Checkout/pages/CheckoutSummary";
import { CollectionListPage } from "../features/Product/pages/CollectionListPage";
import ListPage from "../features/ProductDetail/pages/ListPage";
import GridPage from "../features/ProductDetail/pages/GridPage";
import QRScanner from "../features/Scanner/QRScanner";
import CustomerSearch from "../features/Scanner/CustomerSearch";
import { ComingSoonPage } from "../features/Product/pages/ComingSoonPage";
import OrderPlaced from "../features/Checkout/pages/OrderPlaced";
import Dragondrop from "../features/Account/pages/orders/Dragondrop";
import SearchGridPage from "../features/Search/pages/SearchGridPage";
import SearchMobileGridPage from "../features/Mobile/pages/SearchMobileGridPage";

function AppContent() {
  const location = useLocation();
  const hideLayoutRoutes = [
    "/",
    "/404",
    "/login",
    "/scanner",
    "scanner/qrcode",
  ];
   const hideLayout = hideLayoutRoutes.includes(location.pathname) || location.pathname.startsWith("/ref/");
  return (
    <>
      {!hideLayout && <Navigationbar />}

      <Routes>
       <Route
            path="/"
            element={
              localStorage.getItem("access_token")
                ? <Navigate to="/home" replace />
                : <AuthLoginPage />
            }
          />

           {/* PROTECTED ROUTES */}
        
        <Route
            path="/home"
            element={
              <ProtectedRoute>
                <Homepage />
              </ProtectedRoute>
            }
          />


        <Route
          path="/coming-soon/items"
          element={
            <ProtectedRoute>
              <ComingSoonPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:slug"
          element={
            <ProtectedRoute>
              <CollectionListPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/search"
          element={
            <ProtectedRoute>
              <SearchGridPage />
            </ProtectedRoute>
          }
        />

       <Route
            path="/m/search"
            element={
              <ProtectedRoute>
                    <SearchMobileGridPage/>
              </ProtectedRoute>
            }
          />

        <Route
          path="/products/:slug/grid"
          element={
            <ProtectedRoute>
              <GridPage />
            </ProtectedRoute>
          }
        />

        <Route
            path="/mobile/:slug/list"
            element={
              <ProtectedRoute>
                    <MobileVersionGrid/>
              </ProtectedRoute>
            }
          />

        <Route
          path="/products/:slug/list"
          element={
            <ProtectedRoute>
              <ListPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/wishlist"
          element={
            <ProtectedRoute>
              <Wishlist />
            </ProtectedRoute>
          }
        />

        <Route
          path="/cart"
          element={
            <ProtectedRoute>
              <CartPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/cart-comingsoon"
          element={
            <ProtectedRoute>
              <CartPage />
            </ProtectedRoute>
          }
        />



       {/* 
        <Route
          path="/Cart"
          element={
            <ProtectedRoute>
              <MobileVirsioncart />
            </ProtectedRoute>
          }
        /> */}

        <Route
          path="/checkout/:cart_temp_token/summary"
          element={
            <ProtectedRoute>
              <CheckoutSummary />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ref/:orderToken"
          element={
              <CustomerOrder />
           }
         />


        <Route
          path="/about"
          element={
            <ProtectedRoute>
              <AboutUs />
            </ProtectedRoute>
          }
        />

        <Route
          path="/privacy"
          element={
            <ProtectedRoute>
              <PrivacyPolicy />
            </ProtectedRoute>
          }
        />

        <Route
          path="/account/loyalty"
          element={
            <ProtectedRoute>
              <LoyaltyTerms />
            </ProtectedRoute>
          }
        />


        <Route
          path="/account/dashboard"
          element={
            <ProtectedRoute>
                <Dashboard/>
            </ProtectedRoute>
          }
        />

          <Route
          path="/account/customers"
          element={
            <ProtectedRoute>
                <CustomerPage/>
            </ProtectedRoute>
          }
        />
        <Route
          path="/account/orders"
          element={
            <ProtectedRoute>
               <MyOrders/>
            </ProtectedRoute>
          }
        />

        <Route
        path="/account/orders/bulk-upload"
        element={
           <ProtectedRoute>
               <Dragondrop/>
          </ProtectedRoute>
        }
      />

         <Route
          path="/account/holdorder"
          element={
            <ProtectedRoute>
              <HoldOrder/>
            </ProtectedRoute>
          }
        />

         <Route
            path="/account/orders/:orderNo"
            element={<OrderDetails />}
          />

         <Route
          path="/account/mycollection"
          element={
            <ProtectedRoute>
              <Mycollection/>
            </ProtectedRoute>
          }
        />
        <Route
          path="/account/profile"
          element={
            <ProtectedRoute>
              <MyProfile/>
            </ProtectedRoute>
          }
        />

        <Route
          path="/ChangePassword"
          element={
            <ProtectedRoute>
              <ChangePassword />
            </ProtectedRoute>
          }
        />

      <Route
        path="/checkout/:cart_temp_token/order-success"
        element={
          <ProtectedRoute>
            <OrderPlaced />
          </ProtectedRoute>
        }
      />
     <Route
        path="/scanner/qrcode"
        element={
          <ProtectedRoute>
              <CustomerSearch />
        </ProtectedRoute>
      }
      />  
       <Route
        path="/scanner"
        element={
           <ProtectedRoute>
        <QRScanner />
          </ProtectedRoute>
      }
      />
      <Route 
          path="/404" 
          element={<Notfound />}
        />
      <Route 
        path="*" 
        element={<Navigate to="/404" replace />}
        />
      </Routes>
      {!hideLayout && <Footer />}
      {!hideLayout && <BottomPanel />}
      <ScrollToTop />

    </>
  );
}

export default function AppRoutes() {
  useEffect(() => {
    new WOW.WOW({
      live:false
    }).init();

  }, []);

  return (
    <Router>
      <AppContent />
    </Router>
  );
}